import {openProductPopupHandler} from "./productPopup";

const stockMessage = document.querySelector('.js-popup-stock');

if(stockMessage) {
    stockMessage.addEventListener('click', () => {
        openProductPopupHandler('product-stock');
    });
}
